import {AutofocusEditor} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/property/autofocus/AutofocusEditor';
import {IPropertyTypeConfig} from '@mintdata/mint-kit/api/properties/PropertyTypeConfig';
import {ABoolean} from '@mintdata/mint-kit/api/values/ABoolean';
import {ABooleanConverter} from '@mintdata/mint-kit/impl/properties/converters/ABooleanConverter';

export const AutofocusConfig:IPropertyTypeConfig<ABoolean> =
    {
        converter: ABooleanConverter,
        editor: AutofocusEditor,
    };
